import validate from "D:/word/qctsw-vue/node_modules/.pnpm/nuxt@3.10.1_@opentelemetry+api@1.8.0_@types+node@20.10.3_@unocss+reset@0.60.3_eslint@8.55.0_f_4qqb5mhawrn26h6ep63dhqv3te/node_modules/nuxt/dist/pages/runtime/validate.js";
import navigate_45phone_45global from "D:/word/qctsw-vue/packages/app/src/middleware/navigatePhone.global.ts";
import manifest_45route_45rule from "D:/word/qctsw-vue/node_modules/.pnpm/nuxt@3.10.1_@opentelemetry+api@1.8.0_@types+node@20.10.3_@unocss+reset@0.60.3_eslint@8.55.0_f_4qqb5mhawrn26h6ep63dhqv3te/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  navigate_45phone_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}